export type ChatRole = 'GAME_USER' | 'LIVE_SUPPORT' | 'SUPPORT';
export type ChatTagMessage = 'GAME_USER' | 'SUPPORT';

export type ChatSubscriptionState = 'INITIAL' | 'CHAT_SUBSCRIBED' | 'FRESH_CHAT_SUBSCRIBED';

export interface UserType {
  url: string;
  userId: string;
  tableId: string;
  role: ChatRole;
  tableMinBet: number;
  xForwardedForIP: string;
  rank: number;
  blocked: boolean;
  active: boolean;
  casinoId: string;
  screenName: string;
  userTypeCode: string; // todo: add stricter type
  priveLoungePlayer: boolean;
  chatAllowed: boolean;
  supportChatAllowed: boolean;
  webSocketSessionId: string;
  unMaskedScreenName: string;
  priveLoungeHost: boolean;
  freeGamesCount: number;
  lang: string; // todo: add stricter type
  tableName: string;
  casinoName: string;
  operatorGameTableId: string;
  ppPlayerId: string;
  casinoPPId: string;
  btplayer: boolean;
  hostName: string;
}

export interface Message {
  messageId: string;
  role: ChatRole;
  tagMessage: ChatTagMessage;
  content: string;
  userId?: string;
  timestamp: number;
  user?: UserType;
  userScreenName?: string;
  action?: string; // todo: add stricter type
  autoReply?: false;
  casinoId?: string;
  showHide?: boolean;
  showMessage?: boolean;
  status?: string;
  tableId?: string;
  tableName?: string;
  sendType?: string; // todo: add stricter type
  requireTranslation?: boolean;
  errorCode?: number;
  isliveSupportChat?: boolean;
}

export enum ChatTabType {
  GameChat = 1,
  LiveSupportChat = 2,
}

export interface ChatState {
  gameChatMessages: Message[];
  liveSupportChatMessages: Message[];
  lastMessage: Message | null;
  recentMessages: Message[];
  selectedTab: ChatTabType;
  isLiveSupportChatRead: boolean;
  isChatClosed: boolean;
  displayMiniChat: boolean;
  isGameChatBlocked: boolean;
  isLiveSupportChatBlocked: boolean;
  chatSubscriptionState: ChatSubscriptionState;
}
